import Cookies from 'js-cookie';
import { decryptData } from 'utils/crypto';




export const payrollSteps = () => {
  const role_id = Number(decryptData(Cookies.get('role_id')));
  return [
    {
      target: '[data-tour="payroll-module"]',
      title: '💰 Welcome to Payroll Module',
      content:
        'Manage payroll processing, salary structures, payouts, and employee compensation efficiently from this module.',
      disableBeacon: true,
    },

    {
      target: '[data-tour="payroll-overview-tab"]',
      title: '📊 Overview',
      content: 'Get a high-level summary of payroll activities and insights.',
      disableBeacon: true,
    },

    {
      target: '[data-tour="payroll-assign-structure-tab"]',
      title: '🧾 Assign Structure',
      content: 'Assign salary structures to employees based on roles and policies.',
      disableBeacon: true,
    },

    {
      target: '[data-tour="payroll-create-structure-tab"]',
      title: '🏗 Create Structure',
      content: 'Create and manage salary structures with components like CTC, allowances, and deductions.',
      disableBeacon: true,
    },

    {
      target: '[data-tour="payroll-run-tab"]',
      title: '⚙️ Run Payroll',
      content: 'Process monthly payroll calculations and generate salary outputs.',
      disableBeacon: true,
    },

    {
      target: '[data-tour="payroll-payout-tab"]',
      title: '💸 Payout',
      content: 'Manage salary disbursement and payment processing.',
      disableBeacon: true,
    },

    {
      target: '[data-tour="payroll-variable-tab"]',
      title: '➕ Adoc / Variable',
      content: 'Handle variable pay, bonuses, and ad-hoc salary adjustments.',
      disableBeacon: true,
    },

    {
      target: '[data-tour="payroll-onhold-tab"]',
      title: '⏸ Salary On Hold',
      content: 'Track employees whose salary is temporarily on hold.',
      disableBeacon: true,
    },

    ...(role_id === 1 || role_id === 2
      ? [
        {
          target: '[data-tour="payroll-final-settlement-tab"]',
          title: '📦 Final Settlement',
          content:
            'Process employee full and final settlements including dues and payouts.',
          disableBeacon: true,
        },
      ]
      : []),

    {
      target: '[data-tour="payroll-payslip-tab"]',
      title: '🧾 Pay Slip',
      content: 'View and download your monthly payslips.',
      disableBeacon: true,
    },

    {
      target: '[data-tour="payroll-structure-tab"]',
      title: '📑 Salary Structure',
      content: 'Review your salary breakup and structure details.',
      disableBeacon: true,
    },
  ];
}